exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-30b83046] {\r\n  margin-top: 12px !important;\r\n  font-weight: normal;\n}\n.divContenedor[data-v-30b83046] {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: space-evenly;\r\n      -ms-flex-pack: space-evenly;\r\n          justify-content: space-evenly;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\n}\n.fle[data-v-30b83046] {\r\n  margin: 1.8rem 1rem;\r\n  width: 20rem;\n}\r\n", ""]);

// exports
